import { Inject, Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import {
  AbstractAppConfigService,
  INativeStorageService,
  NATIVE_STORAGE_SERVICE,
} from '../..';
import { AppSettingsService } from '../providers/config.provider';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService extends AbstractAppConfigService {
  constructor(
    @Inject(NATIVE_STORAGE_SERVICE) private localStge: INativeStorageService,
    private platform: Platform,
    private settingsService: AppSettingsService
  ) {
    super();

    this.platform.ready().then(() =>
      this.localStge.getItem('environment').then(
        (rawData) => {
          if (rawData) {
            const env = JSON.parse(rawData) as {
              apiUrl: string;
              instanceName: string;
              type: 'staging' | 'production' | 'custom';
            };
            this.instanceName = env.instanceName;
            this.apiUrl = env.apiUrl;
          } else {
            this.instanceName =
              this.settingsService.getAppEnvironment().instanceName;
            this.apiUrl = this.settingsService.getAppEnvironment().apiUrl;
            //console.warn('---- AppConfigService::NO ENV WAS FOUND');
          }
        },
        (error) => {
          console.error('---- AppConfigService::loadConfig', error);

          this.instanceName =
            this.settingsService.getAppEnvironment().instanceName;
          this.apiUrl = this.settingsService.getAppEnvironment().apiUrl;
        }
      )
    );
  }

  getInstanceName(): string {
    return this.instanceName;
  }
  getApiUrl(): string {
    return this.apiUrl;
  }
}
